var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.isLoginModalOpen)?_c('div',{staticClass:"modal"},[_c('div',{staticClass:"modal-content"},[_c('amplify-authenticator',[_c('div',[_vm._v(" B.A.R.E. Nails ")])])],1)]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }